import { render, staticRenderFns } from "./TablePriorityHandler.vue?vue&type=template&id=353253ff&scoped=true"
import script from "./TablePriorityHandler.vue?vue&type=script&lang=js"
export * from "./TablePriorityHandler.vue?vue&type=script&lang=js"
import style0 from "./TablePriorityHandler.vue?vue&type=style&index=0&id=353253ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353253ff",
  null
  
)

export default component.exports